import * as R from 'ramda';
import { connect } from 'react-redux';

import { TThunkDispatch, IReduxState } from '../../types/redux';
import { setMinArea, setMaxArea } from '../../actions/filters';
import { FilterArea, IFilterAreaProps } from '../../components/FilterArea';

type TFilterAreaStateProps = Pick<IFilterAreaProps, 'value'>;
type TFilterAreaDispatchProps = Pick<IFilterAreaProps, 'setMin' | 'setMax'>;

export function mapStateToProps(state: IReduxState): TFilterAreaStateProps {
  const { jsonQuery } = state.filters;

  return {
    value: R.pathOr({}, ['total_area', 'value'], jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterAreaDispatchProps {
  return {
    setMin: (value: number | undefined) => dispatch(setMinArea(value)),
    setMax: (value: number | undefined) => dispatch(setMaxArea(value)),
  };
}

export const FilterAreaContainer = connect(mapStateToProps, mapDispatchToProps)(FilterArea);
